/**
 * AP Software
 * AP Software REST API.
 *
 * OpenAPI spec version: 3.8.2
 * Contact: support@ap-software.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BankAccount } from './bankAccount';
import { Team } from './team';

export interface Customer { 
    readonly id?: number;
    version?: number;
    created?: Date;
    updated?: Date;
    team?: Team;
    customIdentifier?: string;
    type?: Customer.TypeEnum;
    firstName?: string;
    lastName?: string;
    maidenName?: string;
    privateAddressStreetAndNumber?: string;
    privateAddressAddition?: string;
    privateAddressTownAndPostalCode?: string;
    privateAddressCountry?: string;
    privateMail?: string;
    privatePhone?: string;
    workAddressStreetAndNumber?: string;
    workAddressAddition?: string;
    workAddressTownAndPostalCode?: string;
    workAddressCountry?: string;
    workMail?: string;
    workPhone?: string;
    mobilePhone?: string;
    dayOfBirth?: Date;
    notes?: string;
    bankAccounts?: Array<BankAccount>;
    displayName?: string;
    readonly eTag?: string;
}
export namespace Customer {
    export type TypeEnum = 'OTHER' | 'FEMALE' | 'MALE' | 'COMPANY';
    export const TypeEnum = {
        OTHER: 'OTHER' as TypeEnum,
        FEMALE: 'FEMALE' as TypeEnum,
        MALE: 'MALE' as TypeEnum,
        COMPANY: 'COMPANY' as TypeEnum
    };
}